<template>
  <div id="app" v-cloak :class="{'bg': $route.path.indexOf('/turnoverCabinet') !== -1}" @click.capture="updateTime">
    <router-view/>
    <template v-if="$route.path.indexOf('/turnoverCabinet') !== -1">
    <span
      class="btn-cancel"
      v-text="$route.path === '/turnoverCabinet/saveFinish' ? '结束投递' : '取消操作'"
      @click="cancelBack"
      v-show="!($route.path === '/CConfigSetting' || $route.path === '/turnoverCabinet' || $route.path === '') && $store.state.isShowRBot"></span>
    <!-- <span class="explain" v-show="$store.state.isShowRBot">极酷物联提供技术支持</span> -->
    </template>

    <!--屏保轮播-->
    <div class="screenSaver" v-if="isScreen">
      <swiper id="mySwiperIdle" :options="swiperOption" ref="mySwiperIdle">
        <swiper-slide class="swiperSlide" v-for="(item,index) in adsList" :key="index" >
          <img class="screenCon" :src="item.url" :alt="item.name" v-if="item.type == 'image'" />
          <video :class="'video'+(index+1)" class="screenCon video" :src="item.url" @ended="ended(index)" preload :loop="adsList.length === 1" v-else>您的浏览器不支持 video 标签。</video>
        </swiper-slide>
      </swiper>
    </div>
    
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { storage, clearCountDown } from '../static/turnoverCabinet/js/utility'
import { conLog, messageError } from '../static/js/utils/utility'
import {initWebSocket} from  '../static/js/utils/socket.js'
import { commonApi } from '../static/js/api'
import * as config from '../static/js/config'

let vm, swiperTimer = ''

import axios from 'axios'

export default {
  name: 'App',
  component: {
    swiper,
    swiperSlide
  },
  data(){
    return{
      screenHeight: window.innerHeight,
      screenWidth: window.screen.width,//屏幕宽度

      //屏保设置
      timeOut: 30, //10秒(屏幕倒计时)
      timeStatus:'',
      isScreen: false,
      showIdleAds: this.$route.meta.showIdleAds,
      adsList: [], // 广告列表
      adsTimer: 1000*60*60, // 定时刷新广告内容（每隔一小时）
      // adsTimer: 1000*6, // 定时刷新广告内容（每隔一小时）
      adsRenewal: false,  // 广告内容更新（前后值切换不同，说明已更新）
      ads_start_time: '',  // 平板不操作闲置广告出现时间
      swiperOption: {
        loop: true, // 循环播放
        effect : 'fade', // 切换效果
        observer: true, 
        observeParents: true,
        observeSlideChildren: true,
        on:{
          init: function(){
            let s_vm = this
            // conLog('swiper初始化')
            //Swiper初始化了
            // conLog('当前的slide序号是'+s_vm.activeIndex);
            let activeIndex = s_vm.activeIndex  // 当前是第几屏
            let realIndex = s_vm.realIndex     // 当前索引
            if (vm.adsList[realIndex].type == 'video') {
              // conLog('开始加载视频')
              let slideList = document.getElementById('mySwiperIdle').getElementsByClassName('swiperSlide')
              let videoList = slideList[activeIndex].getElementsByClassName('video')
              // conLog('videoList::::', videoList)
              let mp4 = videoList[0]
              let promise = mp4.play()
              if (promise !== undefined) {
                promise.then(function(){
                  // Autoplay started!

                }).catch(function() {
                  // Autoplay was prevented.
                  // conLog('视频播放错误')
                  //--静音再播放--
                  // mp4.muted=true;
                  mp4.play()
                })
              }
              // conLog('init加载视频完成')
            } else {
              if (vm.adsList.length !== 1) {
                swiperTimer = setTimeout(() => {
                  let toIndex = realIndex+1
                  s_vm.slideToLoop(toIndex == vm.adsList.length ? 0 : toIndex)
                }, vm.adsList[realIndex].delay)
              }
            }
          },
          slideChange:function(){
            let s_vm = this
            let activeIndex = s_vm.activeIndex  // 当前是第几屏
            let realIndex = s_vm.realIndex     // 当前索引
            if (vm.adsList[realIndex].type == 'video') {
              let slideList = document.getElementById('mySwiperIdle').getElementsByClassName('swiperSlide')
              let videoList = slideList[activeIndex].getElementsByClassName('video')
              // videoList[0].play()
              let mp4 = videoList[0]
              let promise = mp4.play()
              if (promise !== undefined) {
                promise.then(function(){
                  // Autoplay started!

                }).catch(function() {
                  // Autoplay was prevented.
                  // conLog('slideChange视频播放错误')
                  //--静音再播放--
                  // mp4.muted=true;
                  mp4.play()
                })
              }
            } else {
              swiperTimer = setTimeout(() => {
                // conLog('-----图片播放结束index', realIndex+1)
                  let toIndex = realIndex+1
                  s_vm.slideToLoop(toIndex == vm.adsList.length ? 0 : toIndex)
              }, vm.adsList[realIndex].delay)
            }
          },
        }
      },

      onLine:false,//当前网络状态
    }
  },
  computed: {
  },
  async created(){
    vm = this
    console.log('route__________', vm.$route)
    //调用广告信息
    if(config.address){
      vm.getAdsList()
    }

    var configStorage = storage.localGetItem('configStorage')
    //判断是否属于工具柜、钥匙柜
    if(configStorage){
      if(configStorage.type == '1' || configStorage.type == '7'){
        initWebSocket();//websocket
      }
    }
    //转换px为rem
    vm.refreshRem(vm.screenWidth);
  },
  mounted () {
    let originalHeight = window.innerHeight
    window.onresize = () => {
      return (() => {
        vm.screenHeight = window.innerHeight
        vm.screenWidth = window.screen.width
        vm.$store.state.isShowRBot = (vm.screenHeight<=(originalHeight+50) && vm.screenHeight>=(originalHeight-50))
        // !(originalHeight > vm.screenHeight)
        // console.log('差值', originalHeight- vm.screenHeight)
        // console.log('原始高度', originalHeight)
        // console.log('当前高度', vm.screenHeight)
      })()
    }
    //监听网络
    var configStorage = storage.localGetItem('configStorage')
    //判断是否属于工具柜、钥匙柜
    if(configStorage){
      if(configStorage.type == '1' || configStorage.type == '7'){
        this.$store.state.onLine = this.onLine
        setInterval(function(){
          vm.updateOnlineStatus();
        },5000)
      }
    }
    
  },
  methods:{
    //转px为rem
    refreshRem(width){
      var that = this
      var doc = window.document;
      var docEl = doc.documentElement;
      if (width > that.$store.state.scrWidth) { // 最大宽度
        width = that.$store.state.scrWidth;
      }
      
      var rem = width / (that.$store.state.scrWidth / 100);
      
      docEl.style.fontSize = rem + 'px';
    },

    //监听是否有网络
    updateOnlineStatus(){
      var that = this;
      axios({
        method: 'get',
        url: config.address+'/api/heartbeat',
      })
      .then(function (res) {
        conLog('成功')
        that.onLine = true
        that.$store.state.onLine = true
      })
      .catch(function (error) {
        conLog('失败',error)
        that.onLine = false
        that.$store.state.onLine = false
      })
    },

    /**
     * 闲置广告设置
     */
    timerGetAdsList (){
      setTimeout(() => {
        vm.getAdsList()
      }, vm.adsTimer)
    },
    play(index) {
      conLog('-----视频播放开始index', index)
    },
    // 监听视频播放结束
    ended (index) {
      // console.log('-----视频播放结束index', index+1)
      let toIndex = index + 1
      vm.$refs.mySwiperIdle.swiper.slideToLoop(toIndex == vm.adsList.length ? 0 : toIndex)
    },
    // 获取闲置广告列表(暂定12小时更新一次)
    async getAdsList (timer) { 
      let data = {
        cabinet_id: config.deviceId,
        type: 'idle'
      }

      let res = await commonApi.getAdsList(data)
      if (res.meta.code === 200) {
        let adsList = res.data.ads_list
        // 如果没有闲置广告，则不显示（不执行）
        adsList.forEach(function (item, index) {
          if(item.type === 'image') {
            adsList[index].delay = res.data.config.rotation_second * 1000
          }
        })
        vm.adsList  = [...adsList]
        vm.ads_start_time = res.data.config.ads_start_time
        console.log('广告内容已更新', '')
        vm.adsRenewal = !(vm.adsRenewal)
        vm.timerGetAdsList()  // 每隔一小时获取一次广告
      } else {
        messageError(res.meta.message)
      }
    },
    // 更新屏保
    updateTime(){
      clearTimeout(this.timeStatus)
      clearTimeout(swiperTimer)
      this.$store.state.fixedAdsPause = false // 打开固定广告视频声音
      this.isScreen = false
      this.timeOut = vm.ads_start_time
      this.overTime(this.timeOut)
    },
    //倒计时
    overTime(wait){
      if (!vm.showIdleAds) {
        return
      }
      var that = this;
      var _wait = wait;
      // console.log('wait', wait)
      if(wait === 0) {
        wait = _wait;
        clearTimeout(that.timeStatus)
        this.$store.state.fixedAdsPause = true // 关闭固定广告视频声音
        that.isScreen = vm.adsList.length !== 0
        console.log('isScreen', that.isScreen)
      } else if(wait > 0) {
        this.timeOut=wait
        wait--;
        that.timeStatus = setTimeout(function() {
          that.overTime(wait);
        },1000);
      }
    },
    cancelBack: function () {
      this.$store.state.type = ''
      clearCountDown()
      this.$router.push({
        // 你要跳转的地址
        path: '/turnoverCabinet'
      })
    }
  },
  watch: {
    '$route':function(newVal, oldVal){
      var that = this
      vm.showIdleAds = newVal.meta.showIdleAds
      // 设置显示闲置广告页面，开始倒计时
      if (vm.showIdleAds) {
        vm.overTime(vm.ads_start_time)
      }
      // console.log('页面更新showIdleAds', vm.showIdleAds)
      if(oldVal.path == '/CConfigSetting'){
        that.$router.go(0)
      }
    },
    //监听屏幕变化
    'screenWidth' (newVal, oldVal) {
      this.refreshRem(newVal)
    },
    //监听参考屏幕值变化
    '$store.state.scrWidth' (newVal, oldVal) {
      console.log('newval',newVal)
      this.refreshRem(this.screenWidth)
    },
    // 监听广告内容是否更新
    'adsRenewal' (newVal) {
      vm.updateTime()
    }
  }
}
</script>

<style lang="less">
[v-cloak] {
  display: none !important;
}
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  font-size: 0.2rem;
  height: 100vh;
  /* background: linear-gradient(#297fb8, #2c3e51); */
}
#app.bg {
  height: 100vh;
  color: #ffffff;
  background:  url(/static/turnoverCabinet/images/bg.jpg) center no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.explain{
  font-size: 0.34rem;
  color: #999999;
  position: fixed;
  right: 0.5rem;
  bottom: 0.4rem;
}

.btn-cancel,
.turnoverCabinet-btn-back {
  display: block;
  width: 2.04rem;
  height: 0.88rem;
  line-height: 0.88rem;
  font-size: 0.34rem;
  border-radius: 0.1rem;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(to top,#0669be, #4babfe);
  position: fixed;
  right: 0.5rem;
  bottom: 1rem;
  /* z-index: 999; */
}

.turnoverCabinet-btn-back {
  right: 2.84rem;
}
.screenSaver{
  touch-action: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  color: #fff;
}
.screenSaver .swiper-container {
  height: 100vh;
  width: 100vw;
  text-align: center;
  .swiper-slide {
    background-color: #cccccc;
  }
  .screenCon {
    display: block;
    width: 100%;
    height: 100%;
    video {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue